import React from 'react';
import { Dumbbell, Heart, ArrowRight } from 'lucide-react';

const ServicesSection: React.FC = () => {
  const services = [
    {
      title: 'BEGINNERS TRAINING',
      icon: Dumbbell,
      image: '/training-beginners.jpg',
      description: 'Perfect for those starting their fitness journey. Learn proper form, build foundational strength, and develop healthy habits with personalized guidance.',
      features: ['One-on-one instruction', 'Form and technique focus', 'Gradual progression', 'Confidence building']
    },
    {
      title: 'PROFESSIONAL ATHLETES',
      icon: Heart,
      image: '/training-professionals.jpg',
      description: 'Advanced training for competitive athletes and fitness enthusiasts. Push your limits with high-intensity workouts and performance optimization.',
      features: ['Sport-specific training', 'Advanced techniques', 'Competition preparation', 'Peak performance coaching']
    }
  ];

  return (
    <section id="services" className="py-20 bg-dark">
      <div className="container mx-auto px-6">
        <h2 className="font-bebas text-5xl md:text-7xl text-center text-white mb-16 tracking-wider">
          OUR <span className="text-primary">SERVICES</span>
        </h2>

        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group relative overflow-hidden bg-black/50 backdrop-blur-sm hover:transform hover:scale-105 transition-all duration-500"
            >
              {/* Background Image */}
              <div className="absolute inset-0 opacity-30 group-hover:opacity-50 transition-opacity duration-500">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover"
                  style={{ 
                    objectPosition: index === 0 ? '50% 30%' : '50% 40%',
                    minHeight: '400px'
                  }}
                />
              </div>

              {/* Content */}
              <div className="relative p-8 lg:p-12">
                <service.icon className="text-primary mb-6" size={48} />
                
                <h3 className="font-bebas text-3xl text-white mb-4 tracking-wider">
                  {service.title}
                </h3>
                
                <p className="text-gray-300 mb-6 font-montserrat">
                  {service.description}
                </p>

                <ul className="space-y-2 mb-8">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="text-gray-400 flex items-center">
                      <ArrowRight className="text-primary mr-2" size={16} />
                      <span className="font-montserrat text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>

                <button className="group/btn flex items-center text-primary font-montserrat font-semibold hover:text-white transition-colors">
                  Learn More 
                  <ArrowRight className="ml-2 group-hover/btn:translate-x-2 transition-transform" size={20} />
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button 
            onClick={() => {
              const element = document.querySelector('#booking');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-primary hover:bg-red-600 text-white font-montserrat font-bold px-8 py-4 text-lg tracking-wider transition-all duration-300 transform hover:scale-105"
          >
            START YOUR JOURNEY
          </button>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;